export default __webpack_public_path__ + "static/media/Spines of Repose.2209a852.jpg";